import potatoChatIcon from '../potato chat icon.png';
import audiomackLogo from '../assets/audiomack-logo.svg';

/**
 * Service icon helpers for category and service displays.
 */

const createSvgDataUri = (svg) => `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;

const linkedInIcon = createSvgDataUri(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#0A66C2">
  <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.03-3.03-1.85-3.03c-1.85 0-2.13 1.45-2.13 2.94v5.66H9.35V9h3.42v1.56h.05c.48-.9 1.64-1.85 3.37-1.85c3.6 0 4.26 2.37 4.26 5.46v6.28zM5.34 7.43a2.07 2.07 0 1 1 0-4.14a2.07 2.07 0 0 1 0 4.14zM7.12 20.45H3.56V9h3.56v11.45z"/>
</svg>
`);

const websiteTrafficIcon = createSvgDataUri(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#2563EB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <circle cx="12" cy="12" r="9"/>
  <path d="M3 12h18"/>
  <path d="M12 3a15 15 0 0 1 0 18"/>
  <path d="M12 3a15 15 0 0 0 0 18"/>
</svg>
`);

const xIcon = createSvgDataUri(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#111827">
  <path d="M18.901 1.153h3.68l-8.04 9.188L24 22.847h-7.406l-5.8-7.584l-6.639 7.584H.474l8.6-9.83L0 1.153h7.594l5.243 6.932l6.064-6.932zm-1.292 19.487h2.039L6.486 3.25H4.298L17.609 20.64z"/>
</svg>
`);

const tiktokIcon = createSvgDataUri(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <path fill="#25F4EE" d="M38.8 11.6c1.6 5.4 5.8 9 11.8 9.4v8.7c-4.3-.1-8.1-1.3-11.4-3.5v14.8c0 9.5-7.5 16.7-17 16.7S5 50 5 40.7c0-8.8 6.8-15.8 15.6-16.6v9.2c-3.9.8-6.6 3.6-6.6 7.4 0 4.3 3.5 7.7 7.9 7.7 4.6 0 7.7-3 7.7-8.4V7h9.2z"/>
  <path fill="#FE2C55" d="M41.4 8.8c1.6 5.4 5.8 9 11.8 9.4v8.7c-4.3-.1-8.1-1.3-11.4-3.5v14.8c0 9.5-7.5 16.7-17 16.7-3.6 0-6.8-1-9.6-2.9 3 3.1 7.2 5 12 5 9.5 0 17-7.2 17-16.7V25.5c3.3 2.2 7.1 3.4 11.4 3.5v-8.7c-6-.4-10.2-4-11.8-9.4h-2.4z"/>
  <path fill="#FFFFFF" d="M40 7c1.6 5.4 5.8 9 11.8 9.4v8.7c-4.3-.1-8.1-1.3-11.4-3.5v14.8c0 9.5-7.5 16.7-17 16.7S6.4 45.9 6.4 36.6c0-8.8 6.8-15.8 15.6-16.6v9.2c-3.9.8-6.6 3.6-6.6 7.4 0 4.3 3.5 7.7 7.9 7.7 4.6 0 7.7-3 7.7-8.4V2.4H40z"/>
</svg>
`);

const PLATFORM_KEYWORDS = [
  'facebook',
  'instagram',
  'tiktok',
  'telegram',
  'whatsapp',
  'youtube',
  'twitter',
  'threads',
  'linkedin',
  'twitch',
  'spotify',
  'soundcloud',
  'google',
  'web service traffic',
  'web traffic',
  'website',
  'traffic',
  'shopee',
  'kick',
  'vk',
  'vimeo',
  'rumble',
  'audio mack',
  'audiomack',
  'reverbnation',
  'rottentomatoes',
  'potato chat members',
  'potato chat',
  'potatochat',
  'potato',
];

export const getServiceToken = (serviceName = '') => {
  const lower = serviceName.toLowerCase();
  const matchedKeyword = PLATFORM_KEYWORDS.find((keyword) => lower.includes(keyword));
  return matchedKeyword || lower.split(/\s+/)[0] || 'service';
};

export const getServiceIcon = (serviceName) => {
  const icons = {
    whatsapp: 'W',
    telegram: 'T',
    facebook: 'f',
    instagram: 'I',
    tiktok: 'T',
    twitter: 'X',
    youtube: 'Y',
    x: 'X',
    threads: '@',
    linkedin: 'in',
    twitch: 'Tw',
    spotify: 'S',
    soundcloud: 'SC',
    google: 'G',
    website: 'WWW',
    shopee: 'Sh',
    kick: 'K',
    vk: 'VK',
    vimeo: 'V',
    rumble: 'R',
    'audio mack': 'A',
    audiomack: 'A',
    reverbnation: 'RN',
    rottentomatoes: 'RT',
    potato: 'P',
    'potato chat': 'P',
    potatochat: 'P',
    'potato chat members': 'P',

    // Unused for now:
    // whatsapp_business: 'WB',
    // discord: 'D',
    // linkedin: 'in',
    // snapchat: 'S',
    // pinterest: 'P',
    // google: 'G',
    // microsoft: 'M',
    // amazon: 'A',
    // uber: 'U',
    // viber: 'V',
    // twitch: 'Tw',
    // reddit: 'R',
    // slack: 'S',
    // wechat: 'W',
    // qq: 'Q',
    // line: 'L',
    // viber_business: 'VB',
    // okta: 'O',
    // twitter_x: 'X',
    // tinder: 'T',
    // bumble: 'B',
    // grindr: 'G',
  };

  return icons[serviceName?.toLowerCase()] || '•';
};

export const getServiceIconAsset = (serviceName) => {
  const assets = {
    whatsapp: 'https://cdn.simpleicons.org/whatsapp/25D366',
    telegram: 'https://cdn.simpleicons.org/telegram/26A5E4',
    facebook: 'https://cdn.simpleicons.org/facebook/1877F2',
    instagram: 'https://cdn.simpleicons.org/instagram/E4405F',
    tiktok: tiktokIcon,
    twitter: xIcon,
    x: xIcon,
    youtube: 'https://cdn.simpleicons.org/youtube/FF0000',
    threads: 'https://cdn.simpleicons.org/threads/111111',
    linkedin: linkedInIcon,
    twitch: 'https://cdn.simpleicons.org/twitch/9146FF',
    spotify: 'https://cdn.simpleicons.org/spotify/1DB954',
    soundcloud: 'https://cdn.simpleicons.org/soundcloud/FF5500',
    google: 'https://cdn.simpleicons.org/google/4285F4',
    shopee: 'https://cdn.simpleicons.org/shopee/EE4D2D',
    kick: 'https://cdn.simpleicons.org/kick/53FC18',
    vk: 'https://cdn.simpleicons.org/vk/0077FF',
    vimeo: 'https://cdn.simpleicons.org/vimeo/1AB7EA',
    rumble: 'https://cdn.simpleicons.org/rumble/85C742',
    'audio mack': audiomackLogo,
    audiomack: audiomackLogo,
    reverbnation: 'https://cdn.simpleicons.org/reverbnation/E43526',
    rottentomatoes: 'https://cdn.simpleicons.org/rottentomatoes/FA320A',
    website: websiteTrafficIcon,
    potato: potatoChatIcon,
    'potato chat': potatoChatIcon,
    potatochat: potatoChatIcon,
    'potato chat members': potatoChatIcon,
  };

  return assets[serviceName?.toLowerCase()] || null;
};

export const getServiceLabel = (serviceName) => {
  const labels = {
    whatsapp: 'WhatsApp',
    telegram: 'Telegram',
    facebook: 'Facebook',
    instagram: 'Instagram',
    tiktok: 'TikTok',
    twitter: 'Twitter',
    x: 'X',
    youtube: 'YouTube',
    threads: 'Threads',
    linkedin: 'LinkedIn',
    twitch: 'Twitch',
    spotify: 'Spotify',
    soundcloud: 'SoundCloud',
    google: 'Google',
    website: 'Website',
    shopee: 'Shopee',
    kick: 'Kick',
    vk: 'VK',
    vimeo: 'Vimeo',
    rumble: 'Rumble',
    'audio mack': 'Audiomack',
    audiomack: 'Audiomack',
    reverbnation: 'ReverbNation',
    rottentomatoes: 'Rotten Tomatoes',
    potato: 'Potato',
    'potato chat': 'Potato Chat',
    potatochat: 'Potato Chat',
    'potato chat members': 'Potato Chat Members',

    // Unused for now:
    // whatsapp_business: 'WhatsApp Business',
    // discord: 'Discord',
    // linkedin: 'LinkedIn',
    // snapchat: 'Snapchat',
    // pinterest: 'Pinterest',
    // google: 'Google',
    // microsoft: 'Microsoft',
    // amazon: 'Amazon',
    // uber: 'Uber',
    // viber: 'Viber',
    // viber_business: 'Viber Business',
    // twitch: 'Twitch',
    // reddit: 'Reddit',
    // slack: 'Slack',
    // wechat: 'WeChat',
    // qq: 'QQ',
    // line: 'LINE',
    // okta: 'Okta',
    // twitter_x: 'Twitter/X',
    // tinder: 'Tinder',
    // bumble: 'Bumble',
    // grindr: 'Grindr',
  };

  return labels[serviceName?.toLowerCase()] || (
    serviceName
      ? serviceName.charAt(0).toUpperCase() + serviceName.slice(1)
      : 'Unknown'
  );
};

export const getServiceColor = (serviceName) => {
  const colors = {
    whatsapp: '#25D366',
    telegram: '#26A5E4',
    facebook: '#1877F2',
    instagram: '#E4405F',
    tiktok: '#25F4EE',
    twitter: '#111827',
    x: '#111827',
    youtube: '#FF0000',
    threads: '#111111',
    linkedin: '#0A66C2',
    twitch: '#9146FF',
    spotify: '#1DB954',
    soundcloud: '#FF5500',
    google: '#4285F4',
    website: '#2563EB',
    shopee: '#EE4D2D',
    kick: '#53FC18',
    vk: '#0077FF',
    vimeo: '#1AB7EA',
    rumble: '#85C742',
    'audio mack': '#FFA200',
    audiomack: '#FFA200',
    reverbnation: '#E43526',
    rottentomatoes: '#FA320A',
    potato: '#2A6DF5',
    'potato chat': '#2A6DF5',
    potatochat: '#2A6DF5',
    'potato chat members': '#2A6DF5',

    // Unused for now:
    // whatsapp_business: '#25D366',
    // discord: '#5865F2',
    // linkedin: '#0A66C2',
    // snapchat: '#FFFC00',
    // pinterest: '#E60023',
    // google: '#4285F4',
    // microsoft: '#0078D4',
    // amazon: '#FF9900',
    // uber: '#000000',
    // viber: '#7360C0',
    // viber_business: '#7360C0',
    // twitch: '#9146FF',
    // reddit: '#FF4500',
    // slack: '#36C5F0',
    // wechat: '#09B83E',
    // qq: '#0066CC',
    // line: '#00B900',
    // okta: '#007DC1',
    // twitter_x: '#111111',
    // tinder: '#FD5068',
    // bumble: '#FFC800',
    // grindr: '#98D8C8',
  };

  return colors[serviceName?.toLowerCase()] || '#3B82F6';
};
